import { render, staticRenderFns } from "./unit-detail-section.vue?vue&type=template&id=42aab96e&scoped=true"
import script from "./unit-detail-section.vue?vue&type=script&lang=js"
export * from "./unit-detail-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aab96e",
  null
  
)

export default component.exports